<div class="dx-card wide-card">
    <h4 class="content-block ap-green">O2 ASU Awards by Region</h4>

    <div class="content-block">
        <o2-report-filters (viewReport)="getO2PortalAwardsByRegion($event)"></o2-report-filters>
        <dx-responsive-box singleColumnScreen="xs sm md">
            <dxi-row [ratio]="1"></dxi-row>
            <dxi-row [ratio]="1"></dxi-row>
            <dxi-col [ratio]=".5"></dxi-col>
            <dxi-col [ratio]=".7"></dxi-col>
            <dxi-col [ratio]=".7"></dxi-col>
            <dxi-col [ratio]=".7"></dxi-col>
            <dxi-item>
                <dxi-location [row]="0" [col]="0" [colspan]="4"></dxi-location>
                <div class="btndiv">
                    <dx-button icon="export" text="Export Charts" type="default" [width]="160" (onClick)="export()">
                    </dx-button>
                </div>
            </dxi-item>
            <dxi-item>
                <dxi-location [row]="1" [col]="0" [colspan]="2"></dxi-location>
                <dx-pie-chart [resolveLabelOverlapping]="resolveOverlappingTypes[0]" id="pie"
                    title="Volume Analysis by Region" palette="soft" [dataSource]="o2PortalAwardsByRegionPieChartData">
                    <dxi-series argumentField="lasuregions" valueField="cumulativePercent">
                        <dxo-label [customizeText]="customizeLabel" [visible]="true">
                            <dxo-connector [visible]="true" [width]="1"></dxo-connector>
                        </dxo-label>
                    </dxi-series>
                    <dxo-size [width]="500"></dxo-size>
                </dx-pie-chart>

            </dxi-item>
            <dxi-item class="marginL30">
                <dxi-location [row]="1" [col]="2" [colspan]="2"></dxi-location>
                <div class="dx-field">
                    <dx-chart [customizePoint]="customizePoint" class="width100" #pivchart id="pivchart"
                        [dataSource]="o2PortalAwardsByRegionBarChartData">
                        <dxo-zoom-and-pan argumentAxis="both"></dxo-zoom-and-pan>
                        <dxo-common-series-settings argumentField="awardYear" valueField="gaseousOxygen"
                            type="stackedBar">
                        </dxo-common-series-settings>
                        <dxi-value-axis position="left">
                            <dxo-title text="Total O2 (mtpd)"></dxo-title>
                        </dxi-value-axis>
                        <dxo-legend verticalAlignment="left" [visible]="false" horizontalAlignment="center"
                            itemTextPosition="top">
                        </dxo-legend>
                        <dxo-tooltip [enabled]="true" location="edge" [customizeTooltip]="customizeTooltip">
                            <dxo-format type="thousands" [precision]="1">
                            </dxo-format>
                        </dxo-tooltip>
                        <dxo-argument-axis [allowDecimals]="false">
                        </dxo-argument-axis>
                        <dxo-series-template nameField="lasuregions"></dxo-series-template>
                        <dxo-scroll-bar [visible]="false"></dxo-scroll-bar>
                    </dx-chart>
                </div>
            </dxi-item>
        </dx-responsive-box>
        <hr />
        <div class="btndiv">
            <dx-button icon="export" text="Export Grids" type="default" [width]="145" (onClick)="exportExcel($event)">
            </dx-button>
        </div>
        <div class="marginT15">
            <h4 class="ap-green lblmargin">Volume Analysis By Competitor & Region</h4>
            <dx-pivot-grid class="grdmargin" #VolumeAnalysisByCompetitorAndRegion
                id="VolumeAnalysisByCompetitorAndRegion" [allowSortingBySummary]="true" [allowFiltering]="false"
                (onCellPrepared)="onCellPrepared($event)" [showBorders]="true" [allowSortingBySummary]="true"
                [showColumnGrandTotals]="true" [showRowGrandTotals]="true" [showRowTotals]="true"
                [showColumnTotals]="false" [dataSource]="pivotGridCompetitorRegionDataSource">
                <dxo-field-chooser [enabled]="false" [height]="400"></dxo-field-chooser>
                <dxo-scrolling mode="virtual"></dxo-scrolling>
            </dx-pivot-grid>
        </div>
        <div class="marginT15">
            <h4 class="lblmargin ap-green">Volume Analysis By Application & Region</h4>
            <dx-pivot-grid class="grdmargin" #VolumeAnalysisByApplicationAndRegion
                id="VolumeAnalysisByApplicationAndRegion" [allowSortingBySummary]="true" [allowFiltering]="false"
                (onCellPrepared)="onCellPrepared($event)" [showBorders]="true" [allowSortingBySummary]="true"
                [showColumnGrandTotals]="true" [showRowGrandTotals]="true" [showRowTotals]="true"
                [showColumnTotals]="false" [dataSource]="pivotGridApplicationRegionDataSource">
                <dxo-field-chooser [enabled]="false" [height]="400"></dxo-field-chooser>
                <dxo-scrolling mode="virtual"></dxo-scrolling>
            </dx-pivot-grid>
        </div>
        <div class="marginT15">
            <h4 class="lblmargin ap-green">Volume Analysis By Process & Region</h4>
            <dx-pivot-grid class="grdmargin" #VolumeAnalysisByProcessAndRegion id="VolumeAnalysisByProcessAndRegion"
                [allowSortingBySummary]="true" [allowFiltering]="false" (onCellPrepared)="onCellPrepared($event)"
                [showBorders]="true" [allowSortingBySummary]="true" [showColumnGrandTotals]="true"
                [showRowGrandTotals]="true" [showRowTotals]="true" [showColumnTotals]="false"
                [dataSource]="pivotGridProcessRegionDataSource">
                <dxo-field-chooser [enabled]="false" [height]="400"></dxo-field-chooser>
                <dxo-scrolling mode="virtual"></dxo-scrolling>
            </dx-pivot-grid>
        </div>
    </div>
</div>